"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _basePath = _interopRequireDefault(require("../common/constants/basePath"));

var _VideoTool = _interopRequireDefault(require("./VideoTool"));

var _ListProjects = _interopRequireDefault(require("./ListProjects"));

var _EditFolder = _interopRequireDefault(require("./EditFolder"));

var _EditProject = _interopRequireDefault(require("./EditProject"));

var _Dashboard = _interopRequireDefault(require("./Dashboard"));

var _CompletedVideo = _interopRequireDefault(require("./CompletedVideo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // App Routes


var _default = [{
  component: _Dashboard.default,
  exact: true,
  path: "".concat(_basePath.default, "/")
}, {
  component: _ListProjects.default,
  exact: true,
  path: "".concat(_basePath.default, "/projects")
}, {
  component: _EditFolder.default,
  path: "".concat(_basePath.default, "/folder/:id")
}, {
  component: _EditProject.default,
  path: "".concat(_basePath.default, "/project/:id")
}, {
  component: _VideoTool.default,
  path: "".concat(_basePath.default, "/builder/:videoId")
}, {
  component: _VideoTool.default,
  path: "".concat(_basePath.default, "/builder")
}, {
  component: _CompletedVideo.default,
  path: "".concat(_basePath.default, "/complete/:videoId/:outputId")
}];
exports.default = _default;